<template>
  <el-form
    v-loading="loading"
    :element-loading-text="$t('messages.cargando')"
    class="ola-form"
    label-position="top"
    @submit.prevent.native="submit()"
  >
    <div
      v-if="response"
      role="alert"
      class="alert retro-response-alert alert-danger"
    >
      <div class="media">
        <img src="images/icon-danger.svg" alt="ícono mensaje" class="mr-3" />
        <div class="media-body" v-html="response.error.message"></div>
      </div>
    </div>

    <div class="form-section row">
      <div class="col-sm-4">
        <div class="form-section-title">
          {{ $t("messages.datos-personales") }}
        </div>
      </div>
      <div class="col-sm-8">
        <div class="row">
          <div class="col-sm-6">
            <el-form-item>
              <label slot="label" for="latamId">Número de socio</label>
              <el-input id="latamId" disabled :value="latamId"></el-input>
            </el-form-item>
          </div>
          <div class="col-sm-6">
            <el-form-item :error="getError('email')">
              <label slot="label" for="email">{{
                $t("messages.correo")
              }}</label>
              <el-input
                id="email"
                ref="email"
                v-model="input.email"
                type="email"
                disabled
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <el-form-item :error="getError('first_name')">
              <label slot="label" for="firstName">{{
                $t("messages.nombre")
              }}</label>
              <el-input
                id="firstName"
                ref="first_name"
                v-model="input.first_name"
              ></el-input>
              <div>{{ $t("messages.debe-coincidir-con-tu-tarjeta") }}</div>
            </el-form-item>
          </div>
          <div class="col-sm-6">
            <el-form-item :error="getError('last_name')">
              <label slot="label" for="lastName">{{
                $t("messages.apellido")
              }}</label>
              <el-input
                id="lastName"
                ref="last_name"
                v-model="input.last_name"
              ></el-input>
              <div>{{ $t("messages.debe-coincidir-con-tu-tarjeta") }}</div>
            </el-form-item>
          </div>
        </div>
      </div>
    </div>

    <div class="form-section row">
      <div class="col-sm-4">
        <div class="form-section-title">
          {{ $t("messages.informacion-del-vuelo") }}
        </div>
      </div>
      <div class="col-sm-8">
        <div class="row">
          <div class="col-sm-12">
            <el-form-item :error="getError('ticket_number')">
              <label slot="label" for="ticketNumber">{{
                $t("messages.nro-de-ticket")
              }}</label>
              <el-input
                id="ticketNumber"
                ref="ticket_number"
                v-model="input.ticket_number"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <el-form-item :error="getError('airline')">
              <label slot="label" for="airline">{{
                $t("messages.aerolinea-del-vuelo")
              }}</label>
              <el-select
                id="airline"
                ref="airline"
                v-model="input.airline"
                filterable
                :placeholder="$t('messages.seleccionar')"
              >
                <el-option
                  v-for="a in airlines"
                  :key="a.id"
                  :label="a.name"
                  :value="a.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="col-sm-6">
            <el-form-item :error="getError('flight_date')">
              <label slot="label" for="flightDate">{{
                $t("messages.fecha-de-viaje")
              }}</label>
              <el-date-picker
                id="flightDate"
                ref="flight_date"
                v-model="input.flight_date"
                type="date"
                placeholder="YYYY-MM-DD"
                :picker-options="{ disabledDate: disabledDate }"
              ></el-date-picker>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <el-form-item :error="getError('origin')">
              <label slot="label" for="originAirport">{{
                $t("messages.ciudad-de-origen")
              }}</label>
              <el-select
                id="originAirport"
                ref="origin"
                v-model="input.origin"
                filterable
                remote
                :remote-method="searchOriginAirports"
                :disabled="!airportsLoaded"
                :placeholder="$t('messages.buscar-y-seleccionar')"
                autocomplete="origin-airport"
              >
                <el-option
                  v-for="(a, key) in originAirports"
                  :key="key"
                  :value="a.id"
                  :label="a.id + ' - ' + a.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="col-sm-6">
            <el-form-item :error="getError('destination')">
              <label slot="label" for="destinationAirport">{{
                $t("messages.ciudad-de-destino")
              }}</label>
              <el-select
                id="destinationAirport"
                ref="destination"
                v-model="input.destination"
                filterable
                remote
                :remote-method="searchDestinationAirports"
                :disabled="!airportsLoaded"
                :placeholder="$t('messages.buscar-y-seleccionar')"
                autocomplete="destination-airport"
              >
                <el-option
                  v-for="(a, key) in destinationAirports"
                  :key="key"
                  :value="a.id"
                  :label="a.id + ' - ' + a.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <el-form-item :error="getError('flight_number')">
              <label slot="label" for="flightNumber">{{
                $t("messages.numero-del-vuelo")
              }}</label>
              <el-input
                id="flightNumber"
                ref="flight_number"
                v-model="input.flight_number"
                type="text"
                maxlength="4"
                placeholder="Ej: 4355"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col-sm-6">
            <el-form-item
              v-if="displayClass"
              :error="getError('booking_class')"
            >
              <label slot="label" for="bookingClass">{{
                $t("messages.clase")
              }}</label>
              <el-input
                id="bookingClass"
                ref="booking_class"
                v-model="input.booking_class"
                type="text"
                :maxlength="1"
                placeholder="Ej: B"
              ></el-input>
            </el-form-item>
          </div>
        </div>
      </div>
    </div>

    <div v-if="displayExtraDocuments" class="form-section row">
      <div class="col-sm-4">
        <div class="form-section-title">
          {{ $t("messages.adjuntar-documentos") }}
        </div>
      </div>
      <div class="col-sm-8">
        <el-form-item
          v-if="displayExtraDocuments.proofOfPurchase"
          label="Comprobante de compra"
          prop="input.proof_of_purchase"
          :error="getError('proof_of_purchase')"
        >
          <el-upload action :http-request="uploadProofOfPurchase">
            <a
              ><img src="images/upload.svg" alt="" />
              {{ $t("messages.subir-imagen") }}</a
            >
          </el-upload>
        </el-form-item>
        <el-form-item
          v-if="displayExtraDocuments.boardingPass"
          label="Boarding pass"
          prop="input.boarding_pass"
          :error="getError('boarding_pass')"
        >
          <el-upload action :http-request="uploadBoardingPass">
            <a
              ><img src="images/upload.svg" alt="" />
              {{ $t("messages.subir-imagen") }}</a
            >
          </el-upload>
        </el-form-item>
        <el-form-item
          v-if="displayExtraDocuments.idDocument"
          :label="$t('messages.documento-de-identificacion')"
          prop="input.id_document"
          :error="getError('id_document')"
        >
          <el-upload action :http-request="uploadIdDocument">
            <a
              ><img src="images/upload.svg" alt="" />
              {{ $t("messages.subir-imagen") }}</a
            >
          </el-upload>
        </el-form-item>
      </div>
    </div>

    <button class="btn btn-primary btn-block">
      {{ $t("messages.enviar-solicitud") }}
    </button>
  </el-form>
</template>
<script>
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import Papa from "papaparse";
import airlines from "../../data/airlines.json";

export default {
  props: {
    ticketNumber: { required: true, type: String },
    callcenter: { default: false, type: Boolean },
    latamId: { default: null, type: String },
    oneworldAaEnabled: { default: false, type: Boolean },
    oneworldAaEndDate: { default: null, type: String },
    oneworldDeltaEnabled: { default: false, type: Boolean },
    me: { required: true, type: Object },
    zendeskTicketId: { default: null, type: String },
  },
  data() {
    return {
      loading: false,
      airportsLoaded: false,
      originAirports: null,
      destinationAirports: null,
      response: null,
      airlines: _(airlines)
        .filter((d) => !d.holding)
        .orderBy("name")
        .value(),
      input: {
        ticket_number: this.ticketNumber,
        first_name: "",
        last_name: "",
        airline: null,
        booking_class: null,
        flight_number: "",
        flight_date: null,
        origin: null,
        destination: null,
        proof_of_purchase: null,
        boarding_pass: null,
        id_document: null,
      },
    };
  },
  computed: {
    displayClass() {
      const airlineSelected = _.find(this.airlines, { id: this.input.airline });
      return airlineSelected && airlineSelected.requiresClass;
    },
    displayExtraDocuments() {
      if (this.callcenter && !this.zendeskTicketId) {
        return null;
      }

      const airlineSelected = _.find(this.airlines, { id: this.input.airline });

      if (!airlineSelected) return false;

      if (
        this.oneworldAaEnabled &&
        airlineSelected.id === "AA" &&
        moment(this.input.flight_date).isAfter(this.oneworldAaEndDate)
      ) {
        return {
          proofOfPurchase: true,
          boardingPass: true,
          idDocument: true,
        };
      }

      if (this.oneworldDeltaEnabled && airlineSelected.id === "DL") {
        return {
          proofOfPurchase: false,
          boardingPass: true,
          idDocument: true,
        };
      }

      return null;
    },
    autofocus() {
      return _.get(this.response, "validation[0].field");
    },
  },
  watch: {
    autofocus(val) {
      if (!val) return;
      this.$refs[val].focus();
    },
    "input.first_name": {
      handler(val) {
        this.input.first_name = _.deburr(val);
      },
    },
    "input.last_name": {
      handler(val) {
        this.input.last_name = _.deburr(val);
      },
    },
  },
  async mounted() {
    this.input.first_name = this.me.first_name;
    this.input.last_name = this.me.last_name;
    this.input.email = this.me.email;

    if (this.zendeskTicketId) {
      axios
        .get(`api/v1/callcenter/zendesk/tickets/${this.zendeskTicketId}`)
        .then((response) => {
          const data = response.data.comments[0].comment;
          const json = JSON.parse(data);
          _.assign(this.input, json);
        })
        .catch(() => {
          // console.log("Zendesk ticket id not found.");
        });
    }

    Papa.parse("data/airports.csv", {
      download: true,
      header: true,
      complete: (results) => {
        this.airports = results.data.map((d) => ({
          id: d.code,
          name: d.name,
        }));
        this.airportsLoaded = true;
      },
    });
  },
  methods: {
    uploadProofOfPurchase(a) {
      const reader = new FileReader();
      reader.readAsDataURL(a.file);
      reader.onload = () => {
        this.input.proof_of_purchase = reader.result;
      };
    },
    uploadBoardingPass(a) {
      const reader = new FileReader();
      reader.readAsDataURL(a.file);
      reader.onload = () => {
        this.input.boarding_pass = reader.result;
      };
    },
    uploadIdDocument(a) {
      const reader = new FileReader();
      reader.readAsDataURL(a.file);
      reader.onload = () => {
        this.input.id_document = reader.result;
      };
    },
    disabledDate(date) {
      return date > new Date();
    },
    searchOriginAirports(query) {
      this.originAirports = this.search(this.airports, query);
    },
    searchDestinationAirports(query) {
      this.destinationAirports = this.search(this.airports, query);
    },
    search(array, query) {
      if (query.length <= 2) return [];

      return array.filter(
        (d) =>
          `${d.id.toLowerCase()} ${d.name.toLowerCase()}`.indexOf(
            query.toLowerCase()
          ) >= 0
      );
    },
    getError(field) {
      if (!this.response) return null;

      return _.get(_.find(this.response.validation, { field }), "message");
    },
    submit() {
      this.loading = true;
      axios
        .post(
          this.callcenter ? "api/v1/callcenter/ola" : "api/v1/ola",
          _.merge(_.cloneDeep(this.input), {
            ticket_number: this.input.ticket_number.replace("-", ""),
            latam_id: this.latamId,
            zendesk_ticket_id: this.zendeskTicketId,
          })
        )
        .then(() => {
          this.$ga?.event?.({
            eventCategory: "ola",
            eventAction: "success",
          });

          window.location.href = this.callcenter
            ? `callcenter/${this.latamId}`
            : "";
        })
        .catch((err) => {
          this.response = err.response.data;
          this.loading = false;

          this.$ga?.event?.({
            eventCategory: "ola",
            eventAction: "reject",
            eventLabel: err.response?.data?.error?.message,
          });
        });
    },
  },
};
</script>

<style lang="scss">
@import "../../scss/variables";

.ola-form {
  background: white;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  padding: 40px;
  .form-section {
    border-top: 1px solid #b8b8b8;
    padding-top: 20px;
    &:first-child {
      border-top: none;
    }
    .form-section-title {
      font-weight: bold;
      color: $teal;
    }
  }
  .el-select {
    display: block;
  }
  .el-date-editor {
    width: 100%;
  }
  .el-form-item__content {
    line-height: inherit;
  }
  .el-form-item__label {
    font-size: 16px;
    color: inherit;
    font-weight: bold;
    line-height: 1;
    padding: 0;
  }
}
</style>
